import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useLockShortcut(onToggleLock: (id: string) => void) {
  const { getNodes } = useReactFlow();
  useKeyboardShortcut(
    { key: 'l', meta: true, shift: true },
    (e) => {
      e.preventDefault();
      const selected = getNodes().filter((n) => n.selected).map((n) => n.id);
      if (selected.length === 0) return;
      for (const id of selected) onToggleLock(id);
    },
  );
}
